import { FC } from 'react';

const SortIcon: FC = () => (
  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="sortIcon">
    <path d="M8 8L4 12L0 8H8ZM0 4L4 0L8 4H0Z" fill="#AAAAAA" />
  </svg>
);

export default SortIcon;
